/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CoordinateSystem } from './CoordinateSystem';
import {
    CoordinateSystemFromJSON,
    CoordinateSystemFromJSONTyped,
    CoordinateSystemToJSON,
} from './CoordinateSystem';

/**
 * 
 * @export
 * @interface GetCoordinateSystems200Response
 */
export interface GetCoordinateSystems200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetCoordinateSystems200Response
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCoordinateSystems200Response
     */
    error: string;
    /**
     * 
     * @type {Array<CoordinateSystem>}
     * @memberof GetCoordinateSystems200Response
     */
    data: Array<CoordinateSystem>;
}

/**
 * Check if a given object implements the GetCoordinateSystems200Response interface.
 */
export function instanceOfGetCoordinateSystems200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "error" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetCoordinateSystems200ResponseFromJSON(json: any): GetCoordinateSystems200Response {
    return GetCoordinateSystems200ResponseFromJSONTyped(json, false);
}

export function GetCoordinateSystems200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCoordinateSystems200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'error': json['error'],
        'data': ((json['data'] as Array<any>).map(CoordinateSystemFromJSON)),
    };
}

export function GetCoordinateSystems200ResponseToJSON(value?: GetCoordinateSystems200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'error': value.error,
        'data': ((value.data as Array<any>).map(CoordinateSystemToJSON)),
    };
}

